export const STRINGS = {
  consentBannerDescription:
    'This site uses cookies to improve your browsing experience, analyze site traffic, and show personalized content. Learn more on',
  and: 'and',
  termsOfServiceLink: 'Terms of Service',
  privacyPolicyLink: 'Privacy Policy',
  consentBannerAccept: 'Accept',
  consentBannerReject: 'Reject',
  consentBannerCustomize: 'Customize',
  privacySettings: 'Privacy Settings',
  // The title the regulations specify for the consolidated opt-out link.
  privacyChoices: 'Your Privacy Choices',
};
